export const MOBILE_BREAKPOINT = 900;
export const SMALL_MOBILE_BREAKPOINT = 500;